import { render, staticRenderFns } from "./orderMaterialPreview.vue?vue&type=template&id=67e508dd&scoped=true&"
import script from "./orderMaterialPreview.vue?vue&type=script&lang=js&"
export * from "./orderMaterialPreview.vue?vue&type=script&lang=js&"
import style0 from "./orderMaterialPreview.vue?vue&type=style&index=0&id=67e508dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e508dd",
  null
  
)

export default component.exports